import type { TaskSummary } from "@/types/tasks";

const MAX_PROMPTS = 4;

export function buildPromptsFromTasks(tasks: TaskSummary[] = []) {
  const normalizedTasks = tasks ?? [];
  const activeTasks = normalizedTasks.filter((task) => !task.isArchived && task.status !== "Archived");
  const prompts: string[] = [];

  if (activeTasks.length > 0) {
    prompts.push(`Summarize your ${activeTasks.length} open tasks`);
  }

  const blockedTask = normalizedTasks.find((task) => task.blockedBy && task.blockedBy.length > 0);
  if (blockedTask) {
    prompts.push("List blockers in this workspace");
  }

  if (activeTasks.length > 0) {
    const targetTask = activeTasks[0];
    prompts.push(`Draft acceptance for Task #${targetTask.id}`);
  }

  const nextTask = activeTasks[1] ?? activeTasks[0];
  if (nextTask) {
    prompts.push(`Outline next steps for ${nextTask.title}`);
  }

  return prompts.filter(Boolean).slice(0, MAX_PROMPTS);
}
